import React, { useState } from "react";

const fetch = require("node-fetch");

const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function parseDate(dateString) {
  if (!dateString) return null;
  return new Date(dateString.split("/").reverse().join("-"));
}

export default function AddressSelect({
  nextFormStep,
  prevFormStep,
  addresses,
  postcode,
  setLoading,
  loading,
  setGardenWasteSubs, // date for Garden waste subs
  setRouteCode,        // e.g. "YG 02 Fri A"
  setCollectionTypeDates,  // e.g. { bin: "Garden", color:"#87a166", date: "Friday 21 November 2025" }

}) {
  const [addressId, setAddressId] = useState(-1);
  const [refuseCollectionError, setRefuseCollectionError] = useState(false);
  const [noItemSelectedError, setNoItemSelectedError] = useState(false);


  function submitForm() {
    if (addressId < 0) {
      setNoItemSelectedError(true);
    } else {
      let callback = function (calanderCode) {
        if (!refuseCollectionError && calanderCode != null) {
          nextFormStep();
        }
      };
      retreiveBinDates(addressId, callback );
    }
  }


  //if the last collection is same day as todays date then use last collection date else use next collection date
  //used to fix error were will not show collection on todays date
  let getNextCollectionDate = (collection) => {
    try{
      if(collection.hso_lastcollection == null){
        return parseDate(collection.hso_nextcollection);
      }

      let lastCollection = parseDate(collection.hso_lastcollection);
      let today = new Date();
      let millisecondsInDay = 86400000;

      if( (Math.floor(today.getTime()/millisecondsInDay)) == (Math.floor((lastCollection.getTime()/millisecondsInDay)))){
        return lastCollection;
      }
      else{
        return parseDate(collection.hso_nextcollection);
      }
    }
    catch(e){
      console.log("ERROR : ", e);
    }
  } 



  async function retreiveBinDates(addressSelected, callback ) {
    setLoading(true);

    //************************************ 
    //*     EXAMPLE DATA - ADDRESSES     *
    //************************************ 

    // House, no garden -> Address: 44, BS30 9UE
    // no data -> Address:19, BS16 7qd
    // Flat ->    Address:5, BS32 9DX
    // UPRN: 596138, no garden --->     10 Melrose Close, BS37 7AY
    // Garden waste sub -> 2 Beaufort Rd, BS37 5DS
    // also garden --->     7 Melrose Close, BS37 7AY
    // AHP ---> 46 Merlin way - BS37 6XR
    // Clincal ---> 132 WATLEYS END ROAD, WINTERBOURNE, BRISTOL, BS36 1QG

    //  ********  LOCAL & TEST USE api-test.southglos,  and PROD use api.southglos  ********
    // let TEST = `https://api-dev.southglos.gov.uk/wastecomp/GetCollectionDetails?uprn=${addressSelected}`;
    let TEST = `https://api-test.southglos.gov.uk/wastecomp/GetCollectionDetails?uprn=${addressSelected}`;
    let PROD =   `https://api.southglos.gov.uk/wastecomp/GetCollectionDetails?uprn=${addressSelected}`; 
    let collectionScheduleURL = ((window.location.host == "localhost:3000") || ( window.location.host ==  "web-apps-asl-d.azurewebsites.net"  )) ?  TEST : PROD; 


    let collectionSchedule = await fetch(collectionScheduleURL).then(
      (response) => {
        setLoading(false);
        if (response.ok) {
          return response.json();
        } else {
          setRefuseCollectionError(true);
          return response.json();
        }
      }
    );

    console.log("collectionSchedule", collectionSchedule);
    
    let GwSubs = getGardenWasteObject(collectionSchedule.value) ? getGardenWasteObject(collectionSchedule.value).hso_subscriptionenddate : null;
    let calanderCode = null;

    if( collectionSchedule.value.length === 0 ){  
      setRefuseCollectionError(true);
    }
    else{

      setCollectionTypeDates(
        collectionSchedule.value.map((colType) => (colType.hso_roundgroup !== "AHP Sacks Holding Round"  && colType.hso_nextcollection !== null?   {   
          bin: colType.hso_servicename,
          color:
            colType.hso_servicename === "Refuse"
              ? "#3c3c3c"
              : colType.hso_servicename === "Food"
              ? "#f59e00"
              : colType.hso_servicename === "Recycling"
              ? "#00853a"
              : colType.hso_servicename === "AHP"
              ? "#72488e"
              : colType.hso_servicename === "Clinical"
              ? "#3c3c3c"
              : "#80ba27", // "Garden"
          textColor:
            colType.hso_servicename === "Refuse"
              ? "#fff"
              : colType.hso_servicename === "Food"
              ? "#3c3c3c"
              : colType.hso_servicename === "Recycling"
              ? "#fff"
              : colType.hso_servicename === "AHP"
              ? "#fff"
              : colType.hso_servicename === "Clinical"
              ? "#fff"
              : "#3c3c3c", // "Garden"    
          date:  `${
            DAYS[getNextCollectionDate(colType).getDay()]
          } ${getNextCollectionDate(colType).getDate()} ${
            MONTHS[getNextCollectionDate(colType).getMonth()]
          } ${getNextCollectionDate(colType).getFullYear()}`,
        } : null ))
      );

      calanderCode = generateCodeFromApiJSON(collectionSchedule);
      if(calanderCode === null){
        setRefuseCollectionError(true);
      }
      else{
        setRouteCode( calanderCode );
      }
    }

    setGardenWasteSubs(GwSubs);

    callback(calanderCode);
  }

  function handleKeyDown(event){
    if (event.key === "Enter") {
      submitForm();
    }
  }

  return (
    <div>
      <a
        className=""
        style={{ textDecoration: "underline", cursor: "pointer" }}
        onClick={prevFormStep}
      >
        <svg
          style={{ transform: "rotate(180deg)" }}
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <g fill="none" fill-rule="evenodd">
            <path
              fill="#00709E"
              fill-rule="nonzero"
              d="M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z"
            />
          </g>
        </svg>
        Back
      </a>
      &nbsp;
      <br />
      <h2>Select your address</h2>
      <strong>{postcode}</strong>&nbsp;-&nbsp;
      <a
        style={{ textDecoration: "underline", cursor: "pointer" }}
        onClick={prevFormStep}
      >
        Change postcode
      </a>
      <br />
      <br />
      {refuseCollectionError && (
        <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>
              We can't find collections that match '{postcode}'. There was a
              problem fetching the data
            </li>
            <li>Try again later.</li>
          </ul>
        </div>
      )}
      {noItemSelectedError && (
        <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>Address is a required field</li>
          </ul>
        </div>
      )}
      <select
        name="addressSelect"
        id="binLookerAddressSelect"
        aria-label="Address Select"
        onChange={(e) => setAddressId(e.target.value)}
        onKeyDown={handleKeyDown}
      >
        <option value="">Select an address</option>
        {Object.entries(addresses).map(([key, value]) => {
          return <option value={value["uprn"]}>{value["address"]}</option>;
        })}
      </select>
      <br />
      <button
        type="button"
        className="button button--primary button__small"
        disabled={loading == true ? "disabled" : ""}
        onClick={submitForm}
        style={{ marginTop: 20 }}
      >
        Continue
      </button>
      <br />
      <br />
    </div>
  );
}


function getGardenWasteObject(unorderedCards){
  let orderedCards = [];
  let order = ["Garden"]; 

  try{
    for(let i in order){
      let searchTerm = order[i];
      for(let j in unorderedCards){ 
        let item = unorderedCards[j].hso_servicename;
        let itemObject = unorderedCards[j];
        if(searchTerm == item){
          if(itemObject.hso_nextcollection !== null){
            orderedCards.push(itemObject);
          }
        }
      }
    }
  }
  catch{
    orderedCards = unorderedCards;
  }
  return orderedCards[0];
}


function generateCodeFromApiJSON(data) {
  let refuseCode = "";
  let recyclingCode = "";
  let gardenWasteCode = "";
  let interimRefuseCode = "";


  for (let i in data.value) {
    if (data.value[i]["hso_servicename"] == "Recycling" && data.value[i]["hso_nextcollection"] !== null ) {
      recyclingCode = data.value[i]["hso_round"];
    }

    if (data.value[i]["hso_servicename"] == "Refuse" && data.value[i]["hso_nextcollection"] !== null) {
      refuseCode = data.value[i]["hso_round"];
    }

    if (data.value[i]["hso_round"] !== null && data.value[i]["hso_round"].match(/^(.*?)(\bINT\b)(.*)$/i)) {
      interimRefuseCode =  data.value[i]["hso_round"];
    }

    if (data.value[i]["hso_servicename"] == "Garden" && data.value[i]["hso_nextcollection"] !== null) {
      gardenWasteCode = data.value[i]["hso_round"];
    }
  }

  //refuseCode = (interimRefuseCode == "") ? refuseCode : interimRefuseCode

  //Temperary rule to catch interim dates that will have no corresponfing collection calander pdf
  if (refuseCode.match(/^(.*?)(\bINT\b)(.*)$/i)){ 
    return "INTERIM";
  }

  //TODO: Plus, (COMMUNAL) is only appended to the end of the address (hso_name) on the Food service

  //updated version should have an address with (COMMUNAL) at the end, this is the only way to determine a flat
  if (data.value[0]["hso_name"].match(/^(.*?)(\b(COMMUNAL)\b)(.*)$/i)){ //flats should have an address with (COMMUNAL) at the end
    return "FLAT";
  }
 
  if (gardenWasteCode.match(/^(.*?)(\bINT\b)(.*)$/i)){ //flats should have an address with (COMMUNAL) at the end
    return "INT";
  }
  
  if( !recyclingCode || !refuseCode ){ //if incorrect data then retrun null
    return null;
  }

  recyclingCode = recyclingCode.replace(/CKNA\s/, "");
  refuseCode = refuseCode
    .replace(/^(?:CR|YR)\s+NA1\s+/, "")
    .replace(/CRNA\s/, "");


  let calendarCode = `${refuseCode}_${recyclingCode}`; 

  if (gardenWasteCode === "") {
    calendarCode = calendarCode
      .replace(/[A-Z]{4} /g, "")  
      .replace(/[A-Z]{2} \d{2} /g, "")
      .replace(/ /g, "%20")
      .replace(/_$/, "");
  } else {
    calendarCode = `${refuseCode}_${recyclingCode}_${gardenWasteCode}`; 
    calendarCode = calendarCode
      .replace(/[A-Z]{4} /g, "")  
      .replace(/[A-Z]{2} \d{2} /g, "")
      .replace(/ /g, "%20");
  }


  return calendarCode;
}
